import { render, staticRenderFns } from "./WaterMark.vue?vue&type=template&id=42b8b76c&scoped=true"
import script from "./WaterMark.vue?vue&type=script&lang=js"
export * from "./WaterMark.vue?vue&type=script&lang=js"
import style0 from "./WaterMark.vue?vue&type=style&index=0&id=42b8b76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8b76c",
  null
  
)

export default component.exports